import './timelineComponent.scss'
import React from 'react';
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";

interface TimelineComponentProps {
    activeStep: number;
    steps: any[];
    position?: 'vertical' | 'horizontal';
    handleStepClick?: Function;
    lastCompletedStep?: number;
}

const TimelineComponent = (props: TimelineComponentProps) => {
        const {activeStep, steps, handleStepClick} = props;
        let {position} = props;
        if (!position) position = "vertical";

        return (
            <div className={'time-line-component'}>
                <Stepper activeStep={activeStep} orientation={position} color="secondary">
                    {steps.map((step: any,index:number) => (
                        <Step key={step.id} onClick={() => {
                            handleStepClick && handleStepClick(step)
                        }}
                              completed={index <= (props?.lastCompletedStep || activeStep) && index !== activeStep}
                        >
                            <StepLabel>{step.title}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </div>
        )

    }

;

export default TimelineComponent;
